<div class="flex flex-col">
  <div class="flex flex-row soft-overline">
    <span>{{item()['begriff']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item()['bezeichnung']}}</span>
  </div>
</div>
